import React from 'react';
import {  Dumbbell, FileText, Users } from 'lucide-react';

interface QuickAction {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  color?: string;
}

interface QuickActionsPanelProps {
  actions?: QuickAction[];
}

const QuickActionsPanel: React.FC<QuickActionsPanelProps> = ({ actions }) => {
  const defaultActions: QuickAction[] = [
   
    {
      label: 'Create Program',
      icon: <Dumbbell size={24} />,
      onClick: () => window.location.href = '/programs/create',
    },
    {
      label: 'View Reports',
      icon: <FileText size={24} />,
      onClick: () => window.location.href = '/billing',
    },
    {
      label: 'Manage Staff',
      icon: <Users size={24} />,
      onClick: () => window.location.href = '/trainers',
    },
  ];

  const displayActions = actions || defaultActions;

  return (
    <div className="bg-gray-900 rounded-lg p-6 border border-gray-800">
      <h3 className="text-white text-lg font-semibold mb-4">Quick Actions</h3>
      
      <div className="grid grid-cols-2 gap-3">
        {displayActions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            className="flex flex-col items-center justify-center p-4 bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors group"
          >
            <div className="text-[#23F47C] mb-2 group-hover:scale-110 transition-transform">
              {action.icon}
            </div>
            <span className="text-white text-sm font-medium text-center">
              {action.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionsPanel;
